import { ProjectWithStats } from './project';
import {
  CHANGE_ACTIVITY_SUCCESS,
  CLEAR_PROJECT,
  CREATE_DEFAULT_CONFIGURATION_SUCCESS,
  GET_PROJECT_SUCCESS,
  GET_PROJECTS_WITH_STATS_SUCCESS,
  ProjectsAction,
  SAVE_CREATED_PROJECT_SNAPSHOT,
  UPDATE_PROJECT_CONFIGURATION_SUCCESS,
  UPDATE_PROJECT_STYLE_SUCCESS
} from './projects.action';
import { createSelector } from 'reselect';
import { Configuration } from '../shared/domain/configuration.model';
import { sumImpressions } from '../../shared/utils/sumImpressions';
import { getActiveTypeLabel } from '../../shared/utils/active-type-formatter';

export interface IProjectsState {
  list: {
    data: ProjectWithStats[];
    total: number;
  };
  activeProject: Configuration;
  createdProjectSnapshot?: Configuration;
}

export const initialState: IProjectsState = {
  list: {
    data: [],
    total: 0
  },
  activeProject: null
};

export function projectsReducer(state = initialState, action: ProjectsAction): IProjectsState {
  switch (action.type) {
    case GET_PROJECTS_WITH_STATS_SUCCESS:
      const data: ProjectWithStats[] = action.payload.map(({ id, active, device, domain, name, activeType, stats }) => {
        const impressions = sumImpressions(stats);
        const leads = (stats && stats.popupSubmitted) || 0;
        return {
          id,
          name,
          activeType: getActiveTypeLabel(activeType),
          status: active,
          device,
          domain,
          impressions,
          leads,
          conversion: impressions ? parseFloat((leads / impressions * 100).toFixed(2)) : 0
        };
      });
      return {
        ...state,
        list: { data, total: data.length }
      };
    case GET_PROJECT_SUCCESS:
    case UPDATE_PROJECT_CONFIGURATION_SUCCESS:
    case UPDATE_PROJECT_STYLE_SUCCESS:
      return {
        ...state,
        activeProject: action.payload
      };
    case CHANGE_ACTIVITY_SUCCESS: {
      const newData = state.list.data.map(
        (project: ProjectWithStats) =>
          project.id === action.payload.projectId ? { ...project, status: action.payload.active } : project
      );
      return {
        ...state,
        list: { ...state.list, data: newData }
      };
    }
    case CLEAR_PROJECT:
      return {
        ...state,
        activeProject: action.payload,
        createdProjectSnapshot: null
      };
    case SAVE_CREATED_PROJECT_SNAPSHOT:
      return {
        ...state,
        createdProjectSnapshot: action.payload
      };
    case CREATE_DEFAULT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        activeProject: action.payload
      };
    default: {
      return state;
    }
  }
}

export const getList = state => state.list.data;
export const getListTotal = state => state.list.total;
export const getActiveProject = state => state.activeProject;
export const getCreatedProjectSnapshot = state => state.createdProjectSnapshot;

export const getMainProjectsSelector = state => state.leadGeneration.projects;
export const getProjectsSelector = createSelector(getMainProjectsSelector, getList);
export const getProjectsTotalSelector = createSelector(getMainProjectsSelector, getListTotal);
export const getActiveProjectSelector = createSelector(getMainProjectsSelector, getActiveProject);
export const getCreatedProjectSnapshotSelector = createSelector(getMainProjectsSelector, getCreatedProjectSnapshot);
